import { useAppSelector } from "../../store/hooks";
import ResourceQualityReportScreen from "../reports/resourceQualityReport";

export default function SharedResourceQualityScreen() {
  const session = useAppSelector(state => state.session);
  return (<div>
    {session.shared?.project ? <ResourceQualityReportScreen project={session.shared.project} /> : <p>You must have a project shared.</p>}
  </div>);
}
